import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import * as util from '../../utils/util';

import './CustomerEmail.css';
import Api from '../../utils/api';
class CustomerEmail extends Component {
    constructor(props){
        super(props);

        this.state = {
            emailInput: '',
            bannerInput: '',
            actionType: 'emailInput',
        };

        this.handleChange = this.handleChange.bind(this);
        this.submitEmail = this.submitEmail.bind(this);
        this.handleKeyPressed = this.handleKeyPressed.bind(this);
        this.submitBranner = this.submitBranner.bind(this);

    }

    componentWillMount() {
        const passwordSubmitted = localStorage.getItem('password_correct');
        const emailSubmitted = localStorage.getItem('email_submitted');
        const userId = localStorage.getItem("user_id");
        if (localStorage.getItem('customer_email')) localStorage.removeItem('customer_email');
        if (emailSubmitted) localStorage.removeItem('email_submitted');
        if (!passwordSubmitted) {   
            this.props.history.push({
                pathname: '/portal'
            });
        }
        if (!userId) {
            this.props.history.push('/signin');
        }
    }

    componentDidMount() {
        // window.addEventListener("beforeunload", this.handleUnload);
    }

    componentWillUnmount() {
        // window.removeEventListener("beforeunload", this.handleUnload);
    }

    handleUnload = (e) => {
        e.preventDefault();
        if (localStorage.getItem('password_correct')) localStorage.removeItem('password_correct');
        return e.returnValue = 'Are you sure you want to close the window?';
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleKeyPressed(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.submitEmail();
        }
    }

    submitEmail() {
        if (!util.isValidEmail(this.state.emailInput)) {
            alert('Not a valid email.');
        } else {
            // if (localStorage.getItem('customer_email')) 
            // localStorage.removeItem('customer_email');
            localStorage.setItem('email_submitted', true);
            this.props.history.push({
                pathname: '/portal/customer-tool/user-info/' + this.state.emailInput
            });
        }
    }

    handleKeyPressedBanerInput(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.submitBranner();
        }
    }

    submitBranner() {
        if (this.state.bannerInput !='') {
            fetch("/api/banners", {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  "x-auth-token":Api.auth_tokenManager()
                },
                body: JSON.stringify({
                    content: this.state.bannerInput   
                })
            }).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    console.log("请求错误");
                }
            })
            .then(responseJson => {
                if(responseJson){
                    alert('update Success');
                    window.location.reload()
                }else{
                    alert('request faill')
                }
            }).catch(function(error) {
                alert(error)
            });
        } else {
            alert('Not a valid bannerInput.'); 
        }
    }
    
    fun_selectTab(value) {
        this.setState({
            actionType: value
        })
    }

    render() {
     
        return (
            <div className="portal-cu-zone">
                <div className="customer-title-tab">
                    <div className={this.state.actionType == 'emailInput' ? "tab-text selectAction" : "tab-text"} onClick={()=>{
                        this.fun_selectTab('emailInput')
                    }}>Customer success</div>

                    <div className={this.state.actionType == 'bannerInput' ? "tab-text selectAction" : "tab-text"} onClick={()=>{
                        this.fun_selectTab('bannerInput')
                    }}>Site banner update tool</div>
                </div>

                <div className="customer-portal" className={this.state.actionType == 'emailInput' ? "customer-portal" : "customer-portal"}   style={this.state.actionType == 'emailInput' ? {display:'flex'}:{display:'none'}}>
                    <div className="title">What’s your customer’s email associated with the account</div>
                    <input className="row-input-but" type="text" name="emailInput" value={ this.state.emailInput } onKeyPress={ this.handleKeyPressed } onChange={this.handleChange} />
                    <div className="submit">
                        <button onClick={ this.submitEmail }>Submit</button>
                    </div>
                </div>

                <div className="customer-portal" name="banner-update-tool"  style={this.state.actionType == 'bannerInput' ? {display:'flex'}:{display:'none'}}>
                    <div className="title">Please put in your update below:</div>
                    <input className="row-input-but" type="text" name="bannerInput" value={ this.state.bannerInput } onKeyPress={ this.handleKeyPressedBanerInput } onChange={this.handleChange} />
                    <div className="submit">
                        <button onClick={ this.submitBranner }>Submit</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(CustomerEmail);



// WEBPACK FOOTER //
// ./src/views/customersuccessportal/CustomerEmail.js